export const environment = {
  appVersion: require('../../package.json').version + '-qa',
  production: false,
  apiKey: 'AIzaSyB0UcoR0JNhlJkETb9LkDYfnjoiTW77GTc',
  apiVersion: 'quarterly',
  version: '3.40',
  gaMeasurementId: 'G-Z56RGJZBS4'
};

export const SERVER_REMOTE_URL : any = [
	{ name: 'dev', is_selected: false, url: 'https://api-next.data-bins.com/ServerApi/v1' },
	{ name: 'qa', is_selected: true, url: 'https://api-qa.data-bins.com/ServerApi/v1' },
	{ name: 'prod', is_selected: false, url: 'https://api-prod.data-bins.com/ServerApi/v1' },
  { name: 'rc', is_selected: false, url: 'https://api-rc.data-bins.com/ServerApi/v1' }
];

export const JSREPORT_URL : any = [
	{ name: 'dev', is_selected: false, url: 'https://jsreport-dev.data-bins.com/api/report' },
	{ name: 'qa', is_selected: true, url: 'https://jsreport-dev.data-bins.com/api/report' },
	{ name: 'prod', is_selected: false, url: 'https://jsreport.data-bins.com/api/report' },
  { name: 'rc', is_selected: false, url: 'https://jsreport.data-bins.com/api/report' }
];

